import React from "react";
import { Box, Divider } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMandatorVisibility } from "@helpers";
import { LoadingButton } from "@rentablo/components";
import { TypographyWithInfoIcon } from "@rentablo/components";
import { useSendKpmgReport } from "@features/settings/useSettings";

type Props = {
  userId: number;
};

export const SendKpmgReportSection = ({ userId }: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const isKpmg = useMandatorVisibility({
    showFor: ["kpmg-germany"],
  });

  const { mutate: sendKpmgReport, isPending: isKpmgReportSending } =
    useSendKpmgReport({
      onSuccess: () => {
        enqueueSnackbar(t("settings.notifications.kpmgReport.success"), {
          autoHideDuration: 2000,
          variant: "success",
          preventDuplicate: true,
        });
      },
      onError: () => {
        enqueueSnackbar(t("settings.notifications.kpmgReport.error"), {
          autoHideDuration: 3000,
          variant: "error",
          preventDuplicate: true,
        });
      },
    });

  const handleSendKpmgReport = () => {
    sendKpmgReport({ userId });
  };

  if (!isKpmg) {
    return null;
  }

  return (
    <>
      <Divider />
      <Box mt={11}>
        <Box display="flex" alignItems="center" gap={2} mb={5}>
          <TypographyWithInfoIcon
            variant="subtitle2"
            tooltipText={t("settings.notifications.kpmgReport.tooltip")}
          >
            {t("settings.notifications.form.investmentReportFrequency")}
          </TypographyWithInfoIcon>
        </Box>
        <LoadingButton
          isFetching={isKpmgReportSending}
          variant="primary"
          onClick={handleSendKpmgReport}
        >
          {t("settings.notifications.kpmgReport.buttonText")}
        </LoadingButton>
      </Box>
    </>
  );
};
